import topBanner from '../../../assets/images/about/strategy/1353.png'

import goal from '../../../assets/images/about/strategy/1353-1.png'
import carriage from '../../../assets/images/about/strategy/1353-31.png'
import intelligent from '../../../assets/images/about/strategy/1353-5.png'
import field from '../../../assets/images/about/strategy/1353-32.png'

import commaUp from '../../../assets/images/about/strategy/comma-up.png'
import commaDown from '../../../assets/images/about/strategy/comma-down.png'

import intelligentIicon1 from '../../../assets/images/about/strategy/intelligent-icon-1.png'
import intelligentIicon2 from '../../../assets/images/about/strategy/intelligent-icon-2.png'
import intelligentIicon3 from '../../../assets/images/about/strategy/intelligent-icon-3.png'
import intelligentIicon4 from '../../../assets/images/about/strategy/intelligent-icon-4.png'
import intelligentIicon5 from '../../../assets/images/about/strategy/intelligent-icon-5.png'

import fieldIcon1 from '../../../assets/images/about/strategy/field-icon-1.png'
import fieldIcon2 from '../../../assets/images/about/strategy/field-icon-2.png'
import fieldIcon3 from '../../../assets/images/about/strategy/field-icon-3.png'

import styles from './style.module.scss'

const intelligentList = [
    {
        index: 1,
        icon: intelligentIicon1,
        title: '感知智能',
        content: [{ index: 1, content: '全方位多视角感知能力' }, { index: 2, content: '更全面的洞悉社会风险' }]
    },
    {
        index: 2,
        icon: intelligentIicon2,
        title: '治理智能',
        content: [{ index: 1, content: '多源数据融合加工能力' }, { index: 2, content: '更深入的挖掘数据价值' }]
    },
    {
        index: 3,
        icon: intelligentIicon3,
        title: '计算智能',
        content: [{ index: 1, content: '海量数据存储计算能力' }, { index: 2, content: '更高效的赋能多元场景' }]
    },
    {
        index: 4,
        icon: intelligentIicon4,
        title: '认知智能',
        content: [{ index: 1, content: '行业属性智能认知能力' }, { index: 2, content: '更智能的识别行业特性' }]
    },
    {
        index: 5,
        icon: intelligentIicon5,
        title: '推演智能',
        content: [{ index: 1, content: '行业场景预判推演能力' }, { index: 2, content: '更精准的辅助行业决策' }]
    }
];

const fieldList1 = [
    { index: 1, icon: fieldIcon2, title: '网络安全' },
    { index: 2, icon: fieldIcon1, title: '公共安全' },
    { index: 3, icon: fieldIcon3, title: '智慧城市' },
];

const fieldList2 = [
    { index: 1, title: '网络安全领域', content: '构建全域网络安全风险的感知、预警、处置能力，为筑牢网络空间防线、打击网络犯罪、推进网络空间治理提供科技支撑。' },
    { index: 2, title: '公共安全领域', content: '构建集资源、能力、服务于一体的警务大数据平台，形成面向多警种的大数据解决方案，提升市域社会治理现代化水平。' },
    { index: 3, title: '智慧城市领域', content: '创新数字化社会治理，助推城市精细治理，守护城市安全，精细服务民生，助力政府更高效地管理城市。' },
];

const Strategy = () => {
    return <div className={styles['strategy-wrapper']}>
        <div className={styles['top-wrapper']}>
            <img src={topBanner} alt="" />
        </div>
        <div className={styles['goal-wrapper']}>
            <div>
                <img src={goal} alt="" />
                <div className={styles['goal-content']}>
                    <img src={commaUp} alt="" />
                    <p>秉持“数字工匠精神”，为各行各业构建核心数据资产</p>
                    <img src={commaDown} alt="" />
                </div>
            </div>
        </div>
        <div className={styles['carriage-wrapper']}>
            <div>
                <img src={field} alt="" />
                <div className={styles['carriage-content']}>
                    <div className={styles['platform-container']}>
                        <div className={styles['title']}>平台</div>
                        <div className={styles['content']}>
                            <p>加强基础平台建设</p>
                            <p>构筑开放高效的智算基座</p>
                        </div>
                    </div>
                    <div className={styles['tool-container']}>
                        <div className={styles['title']}>工具</div>
                        <div className={styles['content']}>
                            <p>打造三类数据工具，培育数字社会治理新动能</p>
                            <div className={styles['tool-wrapper']}>
                                <div className={styles['tool-item']}>
                                    <p>数据治理</p>
                                    <p>盘清数据释放价值</p>
                                </div>
                                <div className={styles['tool-item']}>
                                    <p>分析建模</p>
                                    <p>洞悉业务精准分析</p>
                                </div>
                                <div className={styles['tool-item']}>
                                    <p>应用开发</p>
                                    <p>快速部署多维可视</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles['service-container']}>
                        <div className={styles['title']}>服务</div>
                        <div className={styles['content']}>
                            <p>构建服务运营体系</p>
                            <p>提供数据运营和数据分析专业团队</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className={styles['intelligent-wrapper']}>
            <div>
                <img src={intelligent} alt="" />
                <div className={styles['intelligent-content']}>
                    {intelligentList.map((item) => (
                        <div className={styles['intelligent-item']} key={item.index}>
                            <img src={item.icon} alt="" />
                            <p>{item.title}</p>
                            {item.content.map((value) => (<p key={value.index}>{value.content}</p>))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
        <div className={styles['field-wrapper']}>
            <div>
                <img src={carriage} alt="" />
                <div className={styles['field-content']}>
                    <div className={styles['field-top']}>
                        {fieldList1.map((value) => (
                            <div className={styles['field-item']} key={value.index}>
                                <div> <img src={value.icon} alt="" /></div>
                                <span>{value.title}</span>
                            </div>
                        ))}
                    </div>
                    <div className={styles['field-bottom']}>
                        {fieldList2.map((value) => (
                            <div className={styles['field-item']} key={value.index}>
                                <div className={styles['title']}>{value.title}</div>
                                <div className={styles['content']}>{value.content}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
}
export default Strategy